import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

import { pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';

export default function Alert({
  icon, message, textColor, iconColor, backgroundColor,
}) {
  return (
    <View style={[styles.baseView, { backgroundColor: backgroundColor || appColors.blue }]}>
      <FontAwesome5 name={icon} size={pixelDimensions(4.5)} style={[styles.icon, { color: iconColor || appColors.white }]} />
      <Text style={[styles.text, { color: textColor || appColors.white }]}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  baseView: {
    opacity: 0.8,
    padding: pixelDimensions(2),
    marginVertical: pixelDimensions(2),
    borderRadius: pixelDimensions(1),
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: pixelDimensions(2),
  },
  text: {
    paddingRight: pixelDimensions(2),
  },
});
